(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.BestsellersSection) { window.BestsellersSection.initAll(); return; }
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const slider = root.querySelector('.bs-slider');
    if (!slider) return;
    const breakpoint = window.matchMedia('(max-width: 749px)');
    let swiper = null;
    let timer = null;
    let retries = 0;
    const nav = root.querySelector('.bs-navigation');
    const prev = root.querySelector('.bs-prev');
    const next = root.querySelector('.bs-next');
    const status = root.querySelector('.bs-status');
    const count = slider.querySelectorAll('.bs-card').length;
    function sync() {
      if (!swiper) return;
      if (prev) prev.disabled = swiper.isBeginning;
      if (next) next.disabled = swiper.isEnd;
      if (status) status.textContent = `${swiper.activeIndex + 1} / ${count}`;
    }
    function layout() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (swiper) { swiper.destroy(true, true); swiper = null; }
      root.classList.remove('bs-active');
      if (nav) nav.hidden = true;
      const mobile = breakpoint.matches;
      const cols = Number(mobile ? root.dataset.mobileColumns : root.dataset.columns);
      const enabled = (mobile ? root.dataset.mobile : root.dataset.desktop) === 'true';
      if (!enabled || count <= cols) return;
      if (!window.Swiper) {
        if (retries++ < 40) timer = setTimeout(layout, 250);
        return;
      }
      retries = 0;
      root.classList.add('bs-active');
      swiper = new window.Swiper(slider, {
        slidesPerView: mobile && root.dataset.peek === 'true' ? cols + (cols === 2 ? .4 : .12) : cols,
        spaceBetween: mobile ? 17 : Number(root.dataset.gap),
        watchOverflow: true,
        touchStartPreventDefault: false,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 350,
        on: { slideChange: sync, reachEnd: sync, reachBeginning: sync, resize: sync }
      });
      if (nav) nav.hidden = false;
      sync();
    }
    const goPrev = () => swiper && swiper.slidePrev();
    const goNext = () => swiper && swiper.slideNext();
    if (prev) prev.addEventListener('click', goPrev);
    if (next) next.addEventListener('click', goNext);
    const dialog = root.querySelector('.bs-dialog');
    let lastTrigger = null;
    let previousOverflow = '';
    function openQuick(event) {
      const trigger = event.target.closest('[data-bs-quick-view]');
      if (!trigger || !dialog) return;
      const template = trigger.parentElement.querySelector('.bs-quick-template');
      const content = dialog.querySelector('.bs-dialog-content');
      if (!template || !content) return;
      content.replaceChildren(template.content.cloneNode(true));
      lastTrigger = trigger;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    }
    function closeQuick(event) {
      if (event.target.closest('.bs-dialog-close') || event.target === dialog) dialog.close();
    }
    function restore() { document.body.style.overflow = previousOverflow; if (lastTrigger) lastTrigger.focus(); }
    root.addEventListener('click', openQuick);
    if (dialog) { dialog.addEventListener('click', closeQuick); dialog.addEventListener('close', restore); }
    breakpoint.addEventListener('change', layout);
    layout();
    instances.set(root, () => {
      if (timer) clearTimeout(timer);
      if (swiper) swiper.destroy(true, true);
      if (dialog && dialog.open) dialog.close();
      breakpoint.removeEventListener('change', layout);
      root.removeEventListener('click', openQuick);
      if (prev) prev.removeEventListener('click', goPrev);
      if (next) next.removeEventListener('click', goNext);
      if (dialog) { dialog.removeEventListener('click', closeQuick); dialog.removeEventListener('close', restore); }
      instances.delete(root);
    });
  }
  const initAll = () => document.querySelectorAll('[data-bs-section]').forEach(init);
  window.BestsellersSection = { initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bs-section]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bs-section]').forEach(root => { const destroy = instances.get(root); if (destroy) destroy(); }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq__btn');
    if (!btn) return;
    var item = btn.closest('.faq__item');
    var root = btn.closest('[data-faq]');
    if (!item || !root) return;

    var open = !item.classList.contains('is-open');

    if (open && root.dataset.single === 'true') {
      root.querySelectorAll('.faq__item.is-open').forEach(function (other) {
        if (other === item) return;
        other.classList.remove('is-open');
        other.querySelector('.faq__btn').setAttribute('aria-expanded', 'false');
      });
    }

    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();
})();
